/*!
 * @monogrid/vue-boost v8.0.1 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { defineComponent as e } from "vue";
import { i18n as o, getTranslations as a } from "./index3.mjs";
const i = e({
  name: "LanguageSwitcher",
  setup() {
    const n = o(), t = a();
    return {
      i18n: n,
      locales: t
    };
  }
}), c = i;
export {
  i as LanguageSwitcher,
  c as default
};
